var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdTagAdvert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37 37V8a8 8 0 00-8-8H0z",
    fill: "#FFF0DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.544 6.42l-.877-.622c-.07.326-.184.665-.318 1.011l-2.58-2.58-2.143 2.142c-1.393 1.365-2.666 2.256-3.812 2.666l.064 1.068c1.379-.502 2.85-1.52 4.426-3.055l1.492-1.492 5.184 5.183.65-.65-2.538-2.54c.183-.41.332-.784.452-1.13zm5.24 13.103l-4.738-4.737-2.68 2.68.679.678.34-.34 3.38 3.38-.34.34.679.68 2.68-2.68zm-5.77-2.347l1.075-1.075 3.38 3.38-1.075 1.075-3.38-3.38zm3.804-4.13l1.584 1.584-.976.976-2.97-2.97-.657.658 6.434 6.434.658-.657-2.793-2.793.976-.976 2.255 2.256.644-.644-2.256-2.256.948-.947-.672-.672-.948.948-1.188-1.188c.361-.12.722-.283 1.082-.474l-.58-.75c-.961.51-2 .7-3.125.58l-.127.934c.58.056 1.145.042 1.711-.043z",
    fill: "#E5A344"
  })));
}
export default __webpack_public_path__ + "static/ad-tag-advert.d7d20030.svg";
export { SvgAdTagAdvert as ReactComponent };